<template>
  <div class="container-fluid mt-4 px-1">
    <div class="row gx-3"> 
      <div class="col-md-4">
        <ranking-list-card
          :horizontal-break="false"
          :card="{
            title: '이벤트 데이터',
          }"
          :item="dataList"
        >
        </ranking-list-card>
      </div>


      <div class="col-md-4">
        <div class="card shadow-sm p-4 h-100">
              <div class="col-md-6">
                <h6 class="pb-4 mb-0">입력 데이터</h6>
              </div>
          <form @submit.prevent="submitEvent">
            <!-- 원재료 선택 -->
            <div class="mb-3">
              <label for="epc" class="form-label">포장 재료</label>
              <select v-model="epc" class="form-select" id="epc" >
                <option value="">선택</option>
                <option v-for="item in rawMaterialList" :key="item.id" :value="item.urn">
                  {{ item.name + ' ( ' + item.urn + ' )'}}
                </option>
              </select>
            </div>

            <!-- 스캔장소 (readPoint) -->
            <div class="mb-3">
              <label for="readPoint" class="form-label">스캔장소 (readPoint)</label>
              <select v-model="form.readPoint.manualURI" class="form-select" id="readPoint">
                <option value="">선택</option>
                <option v-for="item in readPointList" :key="item.id" :value="item.urn">
                  {{ item.name + ' ( ' + item.urn + ' )'}}
                </option>
              </select>
            </div>

            <!-- 입고장소 (bizLocation) -->
            <div class="mb-3">
              <label for="bizLocation" class="form-label">업무장소 (bizLocation)</label>
              <select v-model="form.bizLocation.manualURI" class="form-select" id="bizLocation">
                <option value="">선택</option>
                <option v-for="item in bizLocationList" :key="item.id" :value="item.urn">
                  {{ item.name + ' ( ' + item.urn + ' )'}}
                </option>
              </select>
            </div>

            <!-- 수량 -->
            <div class="mb-3">
              <label for="eventTime" class="form-label">이벤트 발생 시간</label>
              <input type="datetime-local" v-model="eventTimeTemp" class="form-control" id="eventTime" />
            </div>

            <!-- 등록 버튼 -->
            <div class="text-end">
              <button type="submit" class="btn btn-success">이벤트 등록</button>
            </div>
          </form>
        </div>
      </div>
      
      <div class="col-md-4">
        <div class="card shadow-sm p-4 h-100">
          <div class="col-md-6">
            <h6 class="pb-4 mb-0">위치정보</h6>
          </div>
          <div class="p-1">
            <map-picker
              :key="mapKey"
              v-model="mapLocation"
              :center="mapCenter"
              :height="'400px'"
              :zoom="13"
              :clickable="false"
            />
          </div>
        </div>
      </div>
    </div>

    <EventListTable
      :eventList="recentEventList"
      :loading="loadingEvents"
      :minBodyHeight="300"
      emptyMessage="최근 이벤트가 없습니다."
    />
  </div>
</template>
<script>
import { fetchBoxData, fetchBizLocationData, fetchReadPointData } from "../../api/common/initDataAPI";
import { pollEpcisEvent, saveBlockChain } from "@/api/common/blockchain.js";
import RankingListCard from "@/examples/Cards/RankingListCard.vue";
import EventListTable from "@/views/components/EventListTable.vue";
import MapPicker from "@/components/map/mapPicker.vue";
import api from '@/api/api';

export default {
  name: "EventPrc2",
  components: {
    RankingListCard,
    EventListTable,
    MapPicker,
  },
  inject: ['showLoading', 'hideLoading'],
  computed: {
    mfId() {
      return this.$store.getters['UserStore/getMfId'];
    },
    dataList() {
      return [{
        title: '이벤트타입',
        date: 'EventType',
        amount: 'ObjectEvent',
        icon: 'fa-info',
        color: 'dark',
      },
      {
        title: '액션',
        date: 'Action',
        amount: 'ADD',
        icon: 'fa-info',
        color: 'dark',
      },
      {
        title: '업무단계',
        date: 'bizStep',
        amount: 'COMMISSIONING',
        icon: 'fa-info',
        color: 'dark',
      },
      {
        title: '처리상태',
        date: 'Disposition',
        amount: 'ACTIVE',
        icon: 'fa-info',
        color: 'dark',
      }
      ]
    },
    mapCenter() {
      if (this.mapLocation) {
        return this.mapLocation;
      }
      const mfInfo = this.$store.getters["UserStore/getMfInfo"];
      if (mfInfo?.lat && mfInfo?.lng) {
        return [mfInfo.lat, mfInfo.lng];
      }
      return [35.8714354, 128.601445]; // 기본 좌표
    },
  },
  watch: {
    'form.readPoint.manualURI'(urn) {
      const sel = this.readPointList.find(r => r.urn === urn);
      if (sel && sel.blId != null) {
        const blId = sel.blId;
        if(blId){
          const selBlId = this.bizLocationList.find(b => b.id === blId);
          if(selBlId) this.form.bizLocation.manualURI = selBlId.urn;
        }
      }
      if (sel && sel.lat != null && sel.lng != null) {
        const lat = Number(sel.lat);
        const lng = Number(sel.lng);
        this.mapLocation = [lat, lng];
        this.mapKey++;
      } else {
        this.mapLocation = null;
        this.mapKey++; // 필요시
      }
    },
  },
  data() {
    return {
      loadingEvents: true,
      epc: '',
      crtEventID: '',  
      eventTimeTemp: '',
      form: {
        parentID: '',
        childEPCs: [],
        eventType: "ObjectEvent",
        action: 'ADD',
        businessStep: 'COMMISSIONING',
        disposition: 'ACTIVE',
        eventTimeSelector: '',
        eventTime: {},
        quantity: '1',
        epcList: [],
        readpointselector: 'manually',
        readPoint: {
          gcpLength: null,
          manualURI: "",
        },
        businesslocationselector: "manually",
        bizLocation: {
          gcpLength: null,
          manualURI: "",
        },
        vocabularySyntax: 'URN',
        ordinaryEvent: true,
        RecordTimeOption: 'no',
        recordTimeType: 'SAME_AS_EVENT_TIME',
        PersistentDispositionType: null,
        PersistentDisposition: null,
        persistentDispositionCount: 0,
        persistentDispositionList: [],
        businessTransactionCount: 0,
        businessTransactionList: [],
        errorCorrectiveCount: 0,
        errorCorrectiveIdsList: [],
        eventID: false,
        eventIdType: 'UUID',
        hashAlgorithm: 'sha-256',
      },
      rawMaterialList: [],
      bizLocationList: [],
      readPointList: [],

      mapLocation: null,
      mapKey: 0,

      recentEventList: [],
    }
  },
  async mounted() {
    this.eventTimeTemp = this.setDefaultTime();

    let now = new Date()
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset())
    now.setSeconds(now.getSeconds(), 0)
    now = now.toISOString().slice(0, -1)

    this.form.eventTime = {
      specificTime: now,
      fromTime: now,
      toTime: now,
      timeZoneOffset: '+09:00'
    }

    this.$store.state.DesignTestDataStore.eventType = "ObjectEvent";
    const [rawList, bizList, readList] = await Promise.all([
      fetchBoxData(this.mfId),
      fetchBizLocationData(this.mfId),
      fetchReadPointData(this.mfId),
    ]);
    this.rawMaterialList = rawList;
    this.bizLocationList = bizList;
    this.readPointList   = readList;
    this.fetchEventListData();
  },
  methods: {
    async submitEvent() {
      this.form.eventTime = this.syncEventTimeFromTemp(this.eventTimeTemp);
      this.showLoading?.('이벤트를 EPCIS에 저장중...');
      try {
        // 1) 시리얼 채번 → epcList 생성
        const response = await api.post("/rawMaterial/maxSerial", { urn: this.epc });
        const result = response.data.result;
        const paddedSerial = String(result.maxSerial).padStart(4, '0');
        this.form.epcList = [ `${this.epc}.${paddedSerial}` ];

        // 2) JSON 템플릿 생성
        this.$store.dispatch('TestDataJsonPreparator/jsonPreparation', { formData: this.form });
        this.$store.commit(
          'TestDataGeneratorStore/populateTestDataInput',
          JSON.stringify(this.$store.state.TestDataJsonPreparator.testDataInputTemplate)
        );
        await this.$store.dispatch('TestDataGeneratorStore/testdataGenerator');
        const dataResult = JSON.stringify(this.$store.state.TestDataGeneratorStore.testDataOutput, null, 2);

        // 3) EPCIS 캡처
        const cap = await this.captureApi(dataResult);
        if (!cap.success) throw new Error(cap.error || 'EPCIS 캡처 실패');

        // 4) EPCIS 폴링
        const committedEvent = await pollEpcisEvent(this.crtEventID, {
          timeout: 60000, startInterval: 800, maxInterval: 4000
        });
        
        this.showLoading?.('이벤트를 블록체인에 저장중...');

        // 5) 블록체인 저장
        await saveBlockChain(this.crtEventID, committedEvent, 60000);

        this.toastSuccess?.('저장 되었습니다.');
        setTimeout(() => this.fetchEventListData(), 1500);
      } catch (e) {
        console.error(e);
        this.toastError?.(e.message || '처리 중 오류 발생');
      } finally {
        this.hideLoading?.();
      }
    },

    // ✅ EPCIS 캡처 (async/await)
    async captureApi(dataResult) {
      try {
        const jsonData = JSON.parse(dataResult);
        const event = jsonData.epcisBody.eventList[0];

        // cbv:extension
        event["cbv:extension"] = { ...(event["cbv:extension"] || {}) };
        if (this.mfId) event["cbv:extension"].companyPrefix = this.mfId;

        // epcList만 사용
        event.epcList = this.form.epcList;
        delete event.parentID;
        delete event.childEPCs;

        // eventID 생성/보관
        if (!event.eventID) {
          const id = crypto?.randomUUID?.() || (Date.now().toString(36) + Math.random().toString(36).slice(2));
          this.crtEventID = `urn:uuid:${id}`;
          event.eventID = this.crtEventID;
        } else {
          this.crtEventID = event.eventID;
        }

        const resp = await fetch(`/api/epcisAPI/capture`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(jsonData),
        });
        if (!resp.ok) throw new Error("응답 오류: " + resp.status);

        const text = await resp.text();
        const result = text ? JSON.parse(text) : {};
        return { success: true, data: result };
      } catch (e) {
        console.error('전송 실패:', e);
        return { success: false, error: e.message || e };
      }
    },
    async fetchEventListData() {
      this.loadingEvents = true;
      try {
        const [res] = await Promise.all([
          api.get(`/event/list`, {
            params: { 
              mfId: this.mfId,
              eventType: this.form.eventType,
              bizStep: this.form.businessStep.toLowerCase(),
              disposition: this.form.disposition.toLowerCase()
            }
          }),
          new Promise(r => setTimeout(r, 600))
        ]);

        const result = res.data.result;
        this.recentEventList = result.recentEventList || [];
      } catch (error) {
        console.error("정보 불러오기 실패:", error);
      } finally {
        this.loadingEvents = false;
      }
    },
  },
};
</script>
